import { styled, css } from '@mui/material/styles';
import { Box, Button as Btn, Typography } from '@mui/material';

export const HeaderDrawer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #bdbdbd;
  padding: 0px 0px 16px;
  position: relative;

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
  }
`;

export const Text = styled(Typography)`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 28px;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;
  color: #212121;
`;

export const Users = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 0px;
  gap: 15px;

  width: 100%;
  height: 62px;

  border-bottom: 1px solid #e0e0e0;
  border-radius: 4px;

  cursor: pointer;

  :hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  .name {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.15px;
    color: #000000;
  }
`;

export const Container = styled(Box)``;

export const Div = styled(Box)`
  .name {
    width: 10vw;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    display: flex;
    align-items: center;
    letter-spacing: 0.1px;
    color: #000000;
  }
  .creator {
    width: 10vw;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.15px;
    color: #000000;
    span {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 20px;
      display: flex;
      align-items: center;
      letter-spacing: 0.4px;
      color: #9e9e9e;
    }
  }
  .data {
    width: 10vw;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.15px;
    color: #000000;
    span {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 20px;
      display: flex;
      align-items: center;
      letter-spacing: 0.4px;
      color: #9e9e9e;
    }
  }
  .items {
    width: 10vw;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.15px;
    color: #000000;
    span {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 20px;
      display: flex;
      align-items: center;
      letter-spacing: 0.4px;
      color: #9e9e9e;
    }
  }
`;

export const Archive = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 10px;
`;

export const ArchiveStyles = styled(Box)`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 20px;

  li {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 8px 15px;
    gap: 10px;
    width: 100%;
    height: 60px;
    background: #ffffff;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    overflow: hidden;
  }
  li:hover {
    background-color: #e9e9e9;
    cursor: pointer;
  }

  ul {
    padding: 0;
    display: flex;
    width: 100%;
    flex-direction: column;
    margin: 0;
    gap: 10px;
  }
`;
export const Buttons = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 7px;
`;

export const Content = styled(Box)`
  .header-guests {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 25px 20px 20px 20px;
    align-items: center;
  }

  .btn-save-guest {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 10px;
    width: 70px;
    height: 36px;
    /* background: rgba(0, 0, 0, 0.12); */
    border-radius: 4px;
  }
  .input-container {
    height: 42px;
    margin: 0px 20px 20px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .name-filter {
    width: 100%;
    height: 42px;
    border: 1px solid #4c4c4c;
    border-radius: 5px;

    padding: 8px 50px;
    opacity: 0.5;

    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    /* identical to box height, or 200% */

    display: flex;
    align-items: center;

    /* Grey/Off Black */

    color: #0e0e2c;
  }
`;
export const SubHeader = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  margin: 0px 20px 20px 20px;

  height: 48px;
  background: ${({ theme }) => theme.palette.common.white};
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12);

  .members {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 33px;
    gap: 10px;
    border-radius: 0;

    width: 160px;
    height: 48px;

    /* White */

    background: ${({ theme }) => theme.palette.common.white};
  }
  .groups {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 33px;
    gap: 10px;
    border-radius: 0;

    width: 160px;
    height: 48px;

    /* White */

    background: ${({ theme }) => theme.palette.common.white};
  }
`;
export const Page = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  margin: 0px 20px 20px 20px;
`;
interface TabSelected {
  active: boolean;
}
export const ButtonMembers = styled(Btn)`
  ${(props: TabSelected) =>
    props.active &&
    css`
      border-bottom: 2px solid #206da7;
    `}
`;

export const FolderType = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
`;

export const FolderTypeTitle = styled(Typography)`
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.15px;
`;

export const SelectedAllBtn = styled(Box)`
  display: flex;
  align-items: center;
  gap: 15px;
  height: 42px;
  border-bottom: 1px solid #e0e0e0;
  margin-top: 5px;

  cursor: pointer;

  :hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

export const TextBtn = styled(Typography)`
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
`;

export const AmountSelectedUsers = styled(Typography)`
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
`;
